import { Outlet, Route, Routes } from '@leagueplatform/routing';

import { AuthViewLogin, AuthViewLogout } from 'pages/auth/Auth.pages';

import {
  AboutMeRoutes,
  LandingPage,
  CareCollectionsRoutes,
  CareDiscoveryRoutes,
  HealthJourneyRoutes,
  HealthNeedPages,
  HealthProfileRoutes,
  HomePage,
  OnboardingRoutesWithProvider,
  WalletRoutes,
  ClaimsRoutes,
  PersonalInformationPage,
  CommunicationPreferencesPage,
  AboutPage,
  NotificationsPage,
  NotificationDetailsPage,
  AchievementsRoutes,
} from 'components/LazyRoutes';

import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { RewardsEventController } from '@leagueplatform/rewards-events';
import { ROUTE_PATHS } from 'common/constants';
import ErrorPage from 'pages/Error404';
import { Onboarding } from 'components/onboarding/onboarding.component';
import { BasePage } from 'components/BasePage';
import { AuthSessionContainer } from 'components/auth-session-container/auth-session-container';
import 'masonry-registries'; // initialize custom masonry registries
import { MemberPathRedirect } from './member-path-redirect/member-path-redirect.component';

const AuthRoutesElement = () => (
  <AuthSessionContainer>
    <Onboarding>
      <BasePage>
        <Outlet />
        <RewardsEventController />
      </BasePage>
    </Onboarding>
  </AuthSessionContainer>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path={`${ROUTE_PATHS.SIGN_IN}/*`} element={<AuthViewLogin />} />
      <Route path={`${ROUTE_PATHS.SIGN_OUT}/*`} element={<AuthViewLogout />} />
      <Route path="/" element={<LandingPage />} />
      <Route element={<AuthRoutesElement />}>
        <Route
          path={`${ROUTE_PATHS.MEMBER_REDIRECT}/*`}
          element={<MemberPathRedirect />}
        />
        <Route path={ROUTE_PATHS.HOME} element={<HomePage />} />
        <Route
          path={ROUTE_PATHS.PERSONAL_INFO}
          element={<PersonalInformationPage />}
        />
        <Route
          path={ROUTE_PATHS.COMMUNICATION_PREFERENCE}
          element={<CommunicationPreferencesPage />}
        />
        <Route path={ROUTE_PATHS.ABOUT} element={<AboutPage />} />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/*`}
          element={<HealthJourneyRoutes />}
          key="health-journey"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthPrograms)}/*`}
          element={<HealthJourneyRoutes />}
          key="health-journey"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthJourneyHistory)}/*`}
          element={<HealthJourneyRoutes />}
          key="health-journey"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthProgress)}/*`}
          element={<HealthJourneyRoutes />}
          key="health-journey"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.aboutMe)}/*`}
          element={<AboutMeRoutes />}
          key="about-me"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.careCollections)}/*`}
          element={<CareCollectionsRoutes />}
          key="care-collections"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.careDiscovery)}/*`}
          element={<CareDiscoveryRoutes />}
          key="care-discovery"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthNeedPages)}/*`}
          element={<HealthNeedPages />}
          key="health-needs"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.wallet)}/*`}
          element={<WalletRoutes />}
          key="wallet"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.healthProfile)}/*`}
          element={<HealthProfileRoutes />}
          key="health-profile"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.onboarding)}/*`}
          element={<OnboardingRoutesWithProvider contentfulId="" tenantId="" />}
          key="onboarding"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.claims)}/*`}
          element={<ClaimsRoutes />}
          key="claims"
        />
        <Route
          path={`${getModulePath(LEAGUE_MODULE_NAMES.rewardsAchievements)}/*`}
          element={<AchievementsRoutes />}
        />
        <Route
          path={ROUTE_PATHS.NOTIFICATIONS}
          element={<NotificationsPage />}
        />
        <Route
          path={`${ROUTE_PATHS.NOTIFICATION_DETAILS}/*`}
          element={<NotificationDetailsPage />}
        />
        <Route element={<ErrorPage />} path="/*" />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
